export default __webpack_public_path__ + "static/media/video_image.3f2aa102.png";